/**
 * Generic function to execute POST requests
 * @param {string} url - The API endpoint
 * @param {Object} data - The request body
 * @param {function} successCallback - Callback function for successful request
 * @param {function} errorCallback - Callback function for failed request
 */
export function postRequest(url, data, successCallback, errorCallback) {
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.Laravel.csrfToken,
            Accept: 'application/json',
        },
        body: JSON.stringify(data),
    })
        .then(response => response.json())
        .then(result => {
            successCallback(result);
        })
        .catch(error => {
            console.error('Error:', error);
            errorCallback(error);
        });
}

/**
 * Generic function to execute GET requests
 * @param {string} url - The API endpoint
 * @param {function} successCallback - Callback function for successful request
 * @param {function} errorCallback - Callback function for failed request
 * @param {boolean} isJson - Flag to indicate if the response should be parsed as JSON
 */
export function getRequest(url, successCallback, errorCallback, isJson = true) {
    fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.Laravel.csrfToken,
            Accept: 'application/json',
        },
    })
        .then(response => (isJson ? response.json() : response.text()))
        .then(result => {
            successCallback(result);
        })
        .catch(error => {
            console.error('Error:', error);
            errorCallback(error);
        });
}

/**
 * Execute a PUT request to the given URL with the provided data
 * @param {string} url - The API endpoint
 * @param {Object} data - The request body
 * @param {function} successCallback - Callback function for successful request
 * @param {function} errorCallback - Callback function for failed request
 * @param {boolean} isJson - Flag to indicate if the response should be parsed as JSON
 */
export function putRequest(url, data, successCallback, errorCallback, isJson = true) {
    fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.Laravel.csrfToken,
            Accept: 'application/json',
        },
        body: JSON.stringify(data),
    })
        .then(response => (isJson ? response.json() : response.text()))
        .then(result => {
            successCallback(result);
        })
        .catch(error => {
            console.error('Error:', error);
            errorCallback(error);
        });
}
